import { ProductColor } from '@aloft/toolkit-sui';

import { OrderTag } from '../../OrderTable/types.ts';

export const getOrderTagBackgroundColor = (tag: OrderTag): ProductColor => {
  switch (tag) {
    case OrderTag.Overdue:
      return 'statusOverdue';
    case OrderTag.ROV:
      return 'statusWarning';
    case OrderTag.Revision:
      return 'statusInProgress';
    case OrderTag.Mock:
      return 'surfaceAccent10';
    case OrderTag.Escalated:
      return 'pinPending';
    case OrderTag.InternalValuation:
      return 'surfaceAccent8';
    default:
      return 'surface1';
  }
};
